var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('feather-icon',{staticClass:"mr-50",attrs:{"icon":_vm.icon,"size":"18"}}),_c('span',{staticClass:"font-weight-bold"},[_vm._v(_vm._s(_vm.text))])],1)}
var staticRenderFns = []

export { render, staticRenderFns }